'use strict';

/**
 * Controller definition for the export dialog
 *
 * @category   Module
 * @module     export
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Backbone = require('backbone');
var ColidoController = require('base/Colido.Controller');
//var ExportLayout = require('./views/layout/export');
//var ExportObjectListLayout = require('./views/layout/export-object-list');

var Controller = ColidoController.extend({
    routes: {
    },

    initialize: function (options) {
        this.module = this.getOption('module');
    },
});

module.exports = Controller;